export default __webpack_public_path__ + "static/media/Crib400.7f351f31.jpg";